// Polyfill for Buffer
import { Buffer } from 'buffer';
window.Buffer = Buffer;